import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';

import { IconMenu2 } from '@tabler/icons-react';
import useAppSettings from 'hooks/useAppSettings';

import LogoSection from '../LogoSection';
import SearchSection from './SearchSection';
import MobileSection from './MobileSection';
import ProfileSection from './ProfileSection';
import MegaMenuSection from './MegaMenuSection';
// import FullScreenSection from './FullScreenSection'; // tela cheia desligada (ver abaixo)
import AppsSection from './AppsSection';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { MenuOrientation } from 'config';
import useConfig from 'hooks/useConfig';

// Empresas, Contratos e Plantões saíram daqui: agora ficam no menu "Apps" (AppsSection), junto com
// os produtos da empresa (Gix Vendas, Gix Interativo). As regras (Setup "Aplicações", lista de orgs)
// estão no ruby4: GET /auth/apps (lib/gix_apps.rb).
export default function Header() {
  const theme = useTheme();
  const downMD = useMediaQuery(theme.breakpoints.down('md'));

  const {
    state: { menuOrientation }
  } = useConfig();

  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = !!menuMaster.isDashboardDrawerOpened;
  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downMD;

  const [isProfileComplete] = useState(true);
  const appSettings = useAppSettings();

  // Opção de Personalização: abre o menu lateral ao carregar (só em telas grandes)
  useEffect(() => {
    if (appSettings.id === undefined) return; // configurações ainda carregando
    handlerDrawerOpen(Boolean(appSettings.sidebar_open_default) && !downMD);
  }, [appSettings.id, appSettings.sidebar_open_default, downMD]);

  useEffect(() => {
    if (!isProfileComplete && drawerOpen) handlerDrawerOpen(false);
  }, [isProfileComplete, drawerOpen]);

  const handleTogglerClick = () => {
    if (!isProfileComplete) {
      handlerDrawerOpen(false);
      return;
    }
    handlerDrawerOpen(!drawerOpen);
  };

  return (
    <>
      <Box sx={{ width: downMD ? 'auto' : 228, display: 'flex' }}>
        <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
          <LogoSection />
        </Box>
        {!isHorizontal && (
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              overflow: 'hidden',
              transition: 'all .2s ease-in-out',
              color: appSettings?.navbar_font_color || theme.vars?.palette?.secondary?.dark || theme.palette.secondary.dark,
              background: appSettings?.navbar_icon_bg_color || theme.vars?.palette?.secondary?.light || theme.palette.secondary.light,
              '&:hover': {
                color: theme.vars?.palette?.secondary?.light || theme.palette.secondary.light,
                background: theme.vars?.palette?.secondary?.dark || theme.palette.secondary.dark
              },
              ...theme.applyStyles?.('dark', {
                color: theme.vars?.palette?.secondary?.main || theme.palette.secondary.main,
                background: theme.vars?.palette?.dark?.main || theme.palette.background.default,
                '&:hover': {
                  color: theme.vars?.palette?.secondary?.light || theme.palette.secondary.light,
                  background: theme.vars?.palette?.secondary?.main || theme.palette.secondary.main
                }
              })
            }}
            onClick={handleTogglerClick}
            aria-disabled={!isProfileComplete}
            title={!isProfileComplete ? 'Complete o cadastro para abrir o menu!' : 'Menu'}
            style={{ cursor: isProfileComplete ? 'pointer' : 'not-allowed' }}
          >
            <IconMenu2 stroke={1.5} size="20px" />
          </Avatar>
        )}
      </Box>

      <SearchSection />
      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />

      <Box sx={{ display: { xs: 'none', md: 'block' } }}>
        <MegaMenuSection />
      </Box>

      {/* Tela cheia desligada (pedido): para voltar, descomente
      <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
        <FullScreenSection />
      </Box>
      */}

      {/* Apps: entre a tela cheia e o usuário */}
      <AppsSection />

      <ProfileSection />

      <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
        <MobileSection />
      </Box>
    </>
  );
}
